import {
  isDropoffLocation,
  isPickupLocation,
} from "../location/isPickupLocation";
import { TripLocationForLoadState } from "./types";

type TrailerGood = {
  _id: string;
  quantity: number;
};

export function getTrailerGoodsAfterStop(
  location: TripLocationForLoadState,
  currentGoods: TrailerGood[],
): TrailerGood[] {
  if (isPickupLocation(location)) {
    const pickedUpGoods = (location.shippedGoods || []).map((good) => ({
      _id: good._id,
      quantity: good.quantity ?? 0,
    }));

    return [...currentGoods, ...pickedUpGoods];
  }

  if (isDropoffLocation(location)) {
    return currentGoods
      .map((good) => {
        const receivedGood = (location.receivedGoods || []).find(
          (received) => received.goodId === good._id,
        );

        if (!receivedGood) {
          return good;
        }

        return {
          ...good,
          quantity:
            good.quantity - (receivedGood.quantity ?? good.quantity),
        };
      })
      .filter((good) => good.quantity > 0);
  }

  return currentGoods;
}

export function isTrailerLoaded(goods: TrailerGood[]): boolean {
  return goods.some((good) => good.quantity > 0);
}

export function isSegmentLoaded(
  locations: TripLocationForLoadState[],
  index: number,
): boolean {
  if (index <= 0) {
    return false;
  }

  let trailerGoods: TrailerGood[] = [];

  for (let i = 0; i < index; i++) {
    trailerGoods = getTrailerGoodsAfterStop(locations[i], trailerGoods);
  }

  return isTrailerLoaded(trailerGoods);
}
